import { LINKS, Percent } from "@silo/types";
import { UnstyledLink } from "../link";
import { ExternalLinkIcon } from "../../icons/external-link";
import { asPercent } from "@silo/utils";

interface RevenueProps {
  revenueApr: Percent;
}

export function Revenue({ revenueApr }: RevenueProps): JSX.Element {
  return (
    <div className="bg-shale-800 rounded-lg px-5 py-3.5">
      <UnstyledLink
        href={LINKS.REVENUE_DETAILS}
        external
        className="flex gap-2.5 items-center font-medium"
      >
        <div>
          Stake SILO:{" "}
          <span className="text-amber-300">{asPercent(revenueApr)}</span>
        </div>

        <div>
          <ExternalLinkIcon className="w-4 h-4 text-shale-400" />
        </div>
      </UnstyledLink>
    </div>
  );
}
